import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

//
import Button from "../button/Button";

const BRANCH_CONTACTS = [
  {
    id: "samarkand",
    title: "appSectSamarkandBranch",
    phone: "+998 (95) 410 00 14",
    href: "tel:+998954100014",
  },
  {
    id: "xatirchi",
    title: "appSectXatirchiBranch",
    phone: "+998 (97) 921 00 14",
    href: "tel:+998979210014",
  },
];

export default function AppoinmentSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledAppoinmentSection>
      <div className="container">
        <div className="appionment-sect__wrap">
          <div className="appionment-sect__left">
            <h1 dangerouslySetInnerHTML={{ __html: t("appSectTitle") }} />
            <Button onClick={() => handleNavigate("/contact")} hover="white">
              {t("appSectBtn")}
            </Button>
          </div>
          <div className="appionment-sect__right">
            <p>{t("appSectText")}</p>
            <div className="appionment-sect__contacts">
              {BRANCH_CONTACTS.map((contact) => (
                <div
                  className="appionment-sect__contact-card"
                  key={contact.id}
                >
                  <h2>{t(contact.title)}</h2>
                  <a href={contact.href}>
                    <i className="icon icon-phone" aria-hidden="true"></i>
                    <b>{contact.phone}</b>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </StyledAppoinmentSection>
  );
}

const StyledAppoinmentSection = styled.section`
  background-color: var(--dark-blue);
  padding: 80px 0;

  .appionment-sect {
    &__wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 32px;
    }

    &__left {
      h1 {
        color: var(--white);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 32px;
      }
    }

    &__right {
      width: 100%;
      max-width: 650px;

      p {
        color: var(--white);
        font-size: var(--fs-body-lg);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-body-lg);
        margin-bottom: 36px;
      }
    }

    &__contacts {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
    }

    &__contact-card {
      padding: 18px 22px;
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 18px;
      background-color: rgba(255, 255, 255, 0.07);

      h2 {
        margin-bottom: 12px;
        color: var(--white);
        font-size: 16px;
        font-weight: var(--fw-semibold);
        line-height: 1.4;
      }

      a {
        display: flex;
        align-items: center;
        gap: 12px;

        i {
          flex: 0 0 auto;
          width: 22px;
          height: 22px;
          background-color: var(--extra-light-blue);
        }

        b {
          color: var(--extra-light-blue);
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: 1.35;
          white-space: nowrap;
        }

        &:focus-visible {
          outline: 2px solid var(--extra-light-blue);
          outline-offset: 5px;
          border-radius: 4px;
        }
      }
    }
  }

  @media (max-width: 1050px) {
    .appionment-sect {
      &__wrap {
        align-items: stretch;
        flex-direction: column;
      }

      &__right {
        max-width: none;
      }
    }
  }

  @media (max-width: 640px) {
    .appionment-sect {
      &__contacts {
        grid-template-columns: 1fr;
      }

      &__contact-card {
        padding: 16px 18px;

        a {
          b {
            font-size: 20px;
          }
        }
      }
    }
  }
`;
